if (!window.btSignalsGetGuestId) {
  window.btSignalsGetGuestId = () => {
    const storageKey = 'btSignalsGuestId';
    const guestIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    let storedId;

    try {
      storedId = window.localStorage.getItem(storageKey);
      if (guestIdPattern.test(storedId || '')) return storedId;
    } catch (_error) {
      // Use a transient ID when browser storage is unavailable.
    }

    const guestId = window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : (() => {
          const bytes = new Uint8Array(16);
          window.crypto.getRandomValues(bytes);
          bytes[6] = (bytes[6] & 0x0f) | 0x40;
          bytes[8] = (bytes[8] & 0x3f) | 0x80;
          const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
          return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
        })();

    try {
      window.localStorage.setItem(storageKey, guestId);
    } catch (_error) {
      return guestId;
    }

    return guestId;
  };
}